import React, { useState, useEffect } from 'react'
import { ApolloError } from '@apollo/client'
import classNames from 'classnames'
import { IScraperJobConfigurationFragment } from 'apps/spot-quote-control-panel/graphql/ScraperJobConfigurationFragment'
import { IUpdateScraperJobConfigurationsMutation } from 'apps/spot-quote-control-panel/graphql/UpdateScraperJobConfigurationsMutation'
import { useDefaultAutobiddersFilters } from 'apps/spot-quote-control-panel/hooks/useDefaultAutobiddersFilters'
import { useJobConfigs } from 'apps/spot-quote-control-panel/hooks/useJobConfigs'
import { useJobMetadata } from 'apps/spot-quote-control-panel/hooks/useJobMetadata'
import { TAutobiddersFiltersSchema } from 'apps/spot-quote-control-panel/schema/AutobiddersFiltersSchema'
import { groupJobConfigsByTms } from 'apps/spot-quote-control-panel/utils/groupJobConfigsByTms'
import { Container } from 'components/layout'
import { AppliedFilters } from './AppliedFilters'
import { AutobiddersFilters } from './AutobiddersFilters'
import { TmsTable } from './TmsTable'
import { UpdateAutobidderConfigForm } from './UpdateAutobidderConfigForm/UpdateAutobidderConfigForm'

export interface IUpdateScraperJobConfigurationsResult {
  data: IUpdateScraperJobConfigurationsMutation | null | undefined
  loading: boolean
  error: ApolloError | undefined
}

export const AutobiddersPanel = () => {
  const defaultFilters = useDefaultAutobiddersFilters()
  const [filters, setFilters] = useState<TAutobiddersFiltersSchema>(defaultFilters)
  const { jobConfigs, jobConfigsLoading, refetchJobConfigs } = useJobConfigs({ filters })
  const { metadata, metadataLoading } = useJobMetadata()
  const configsByTms = groupJobConfigsByTms(jobConfigs)
  const [focusedJob, setFocusedJob] = useState<IScraperJobConfigurationFragment>()

  const filterContainerClasses = classNames('modal-container', {
    active: focusedJob !== undefined,
  })

  useEffect(() => {
    refetchJobConfigs()
  }, [filters])
  useEffect(() => {
    if (focusedJob === undefined) {
      refetchJobConfigs()
    }
  }, [focusedJob])

  return (
    <Container>
      <div className={filterContainerClasses}>
        {focusedJob !== undefined && (
          <UpdateAutobidderConfigForm jobConfig={focusedJob} setFocusedJob={setFocusedJob} />
        )}
      </div>
      {metadataLoading ? (
        <div />
      ) : (
        <div>
          <AutobiddersFilters metadata={metadata} filters={filters} setFilters={setFilters} />
          <AppliedFilters
            bidderFilters={filters}
            defaultFilters={defaultFilters}
            setFilters={setFilters}
          />
        </div>
      )}
      {!jobConfigsLoading &&
        configsByTms.map(job => (
          <TmsTable
            jobConfigs={job}
            setFocusedJob={setFocusedJob}
            tmsName={job[0].tmsName}
            key={job[0].tmsName}
          />
        ))}
    </Container>
  )
}
